import { useState } from 'react';

const faqItems = [
  {
    q: '韩漫屋真的完全免费吗？需要注册吗？',
    a: '是的，韩漫屋所有韩漫内容完全免费开放，无需注册登录即可阅读全部章节。我们坚持韩漫全集免费看的理念，让每一位韩漫爱好者都能零门槛享受阅读乐趣。',
  },
  {
    q: '韩漫屋的更新频率是怎样的？',
    a: '韩漫屋坚持每日同步更新策略，热门连载的韩漫免费全集在线内容与韩国本土更新节奏保持一致。我们的编辑团队持续监控各大韩漫平台动态，确保第一时间将最新话呈现在读者面前。',
  },
  {
    q: '韩漫屋支持哪些设备阅读？',
    a: '韩漫屋采用响应式设计，完美适配桌面电脑、平板和手机等多种设备。特别是针对手机竖屏进行了专项优化，配合下拉式阅读体验，让移动端阅读如翻阅纸质漫画般自然流畅。',
  },
  {
    q: '如果遇到加载慢或图片无法显示怎么办？',
    a: '建议首先检查网络连接状态，尝试切换Wi-Fi或移动数据。如果问题持续存在，可以通过联系我们页面反馈具体作品名称和问题描述，我们的技术团队会尽快排查修复。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于韩漫屋的常见疑问，这里都有答案。如有更多问题欢迎通过联系我们反馈
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left cursor-pointer hover:bg-background-50/50 transition-colors"
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <span className={`flex-shrink-0 w-8 h-8 rounded-full bg-background-100 flex items-center justify-center transition-transform duration-200 ${openIndex === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-600"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 pb-5 md:pb-6 px-5 md:px-6' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}